// El monto de una colecta: sin moneda (la da el OPL), con $ y hasta cuatro
// decimales. Entero, sin decimales; con decimales, al menos dos.
export const AMOUNT_DECIMALS = 4;
export const AMOUNT_MAX = 9999999999.9999;
const FACTOR = 10 ** AMOUNT_DECIMALS;
const FORMATTER = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 });
const FORMATTER_DECIMALS = new Intl.NumberFormat('es-AR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: AMOUNT_DECIMALS,
});

export const roundAmount = (value: number): number =>
  Math.round(value * FACTOR) / FACTOR;

export const NO_AMOUNT = 'Sin monto';

export const hasAmount = (value?: number | null): value is number =>
  value != null && !Number.isNaN(Number(value));

export const formatAmount = (value?: number | null): string => {
  if (!hasAmount(value)) return NO_AMOUNT;
  const amount = Number(value);
  const formatter = Number.isInteger(roundAmount(amount))
    ? FORMATTER
    : FORMATTER_DECIMALS;
  return `$${formatter.format(amount)}`;
};

export const amountChangeText = (
  from?: number | null,
  to?: number | null,
): string => `Monto: ${formatAmount(from)} → ${formatAmount(to)}`;
